import type { FieldValue } from "@components/job_post/field";

export function isSamePhoneNumber(a: FieldValue, b: FieldValue): boolean {
  const digitsA = typeof a === "string" ? a.replace(/\D/g, "") : "";
  const digitsB = typeof b === "string" ? b.replace(/\D/g, "") : "";
  if (digitsA === digitsB) return true;
  return (
    digitsA !== "" && digitsB !== "" && (digitsA.endsWith(digitsB) || digitsB.endsWith(digitsA))
  );
}
